module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-3-337e13d6.png";